"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relationsDto = void 0;
exports.relationsDto = [
    "you",
    "spouse",
    "aunt-uncle",
    "child-dependant",
    "grandchild",
    "cousin",
    "grandparent",
    "niece-nephew",
    "parent-guardian",
    "partner",
    "sibling",
    "other"
];
